module.exports = __webpack_public_path__ + "img/shortcut-booking-ilustration.9e5155c3.svg";